import { Route } from 'react-router';
import { EnsureResourcesLoaded } from './EnsureResourcesLoaded';
import { ResourcesPage } from './ResourcesPage';
import { ResourceDetailsPage } from './ResourceDetailsPage';

export const ResourcesRouteHandler: React.FC = () => (
    <Route path="/resources">

        <EnsureResourcesLoaded />

        <Route exact path="/resources">
            <ResourcesPage />
        </Route>

        <Route exact path="/resources/:slug" render={routeParams => (
            <ResourceDetailsPage slug={routeParams.match.params.slug} />
        )} />

    </Route>
);
